import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { PermissionCatalogItem } from "@/actions/ssr/settings/getPermissionCatalogSSR";

interface PermissionCatalogState {
  items: PermissionCatalogItem[];
  totalPages: number;
  currentPage: number;
  totalItems: number;
}

const initialState: PermissionCatalogState = {
  items: [],
  totalPages: 1,
  currentPage: 1,
  totalItems: 0,
};

const permissionCatalogSlice = createSlice({
  name: "permissionCatalog",
  initialState,
  reducers: {
    setPermissionCatalogItems(
      state,
      action: PayloadAction<PermissionCatalogItem[]>,
    ) {
      state.items = action.payload;
    },
    setPermissionCatalogPagination(
      state,
      action: PayloadAction<{
        totalPages: number;
        currentPage: number;
        totalItems?: number;
      }>,
    ) {
      state.totalPages = action.payload.totalPages;
      state.currentPage = action.payload.currentPage;
      if (action.payload.totalItems !== undefined) {
        state.totalItems = action.payload.totalItems;
      }
    },
  },
});

export const { setPermissionCatalogItems, setPermissionCatalogPagination } =
  permissionCatalogSlice.actions;
export default permissionCatalogSlice.reducer;
